"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const surface_1 = require("../../../../../../surface");
const links_1 = require("../../../../../utils/links");
const CheckboxWidget = ({ label, value, disabled, readonly, onChange, id, formContext }) => (jsx_runtime_1.jsx(surface_1.Check, { showLabel: true, label: label, checked: typeof value === 'undefined' ? false : value, disabled: disabled || readonly || links_1.isLockedWidget(id, formContext.links), handleChange: (event) => onChange(event.target.checked) }, void 0));
exports.default = CheckboxWidget;
//# sourceMappingURL=index.js.map